import { BBPBaseService } from "./BBPBaseService";
export class BBPBackendService extends BBPBaseService {
    constructor(fetchImpl) {
        super(process.env.BBPPAIRING_ENDPOINT ?? "", fetchImpl);
    }
    async getAuthHeaders() {
        return {
            "x-api-key": `${process.env.BBPPAIRING_API_KEY}`,
        };
    }
}
